export { default as DotsAnimation } from './DotsAnimation.vue'
export { default as SpinnerAnimation } from './SpinnerAnimation.vue'
export { default as VanAnimation } from './VanAnimation.vue'
export { default as CoachBusAnimation } from './CoachBusAnimation.vue'
export { default as SchoolBusAnimation } from './SchoolBusAnimation.vue'
export { default as ShuttleAnimation } from './ShuttleAnimation.vue'
export { default as LimoAnimation } from './LimoAnimation.vue'
export { default as TaxiAnimation } from './TaxiAnimation.vue'

// Map animation keys to components
export const animationComponents = {
  'dots': 'DotsAnimation',
  'van': 'VanAnimation',
  'coach': 'CoachBusAnimation',
  'school': 'SchoolBusAnimation',
  'shuttle': 'ShuttleAnimation',
  'limo': 'LimoAnimation',
  'taxi': 'TaxiAnimation',
  'spinner': 'SpinnerAnimation',
}
